module.exports = __webpack_public_path__ + "static/media/Accenture_app_instructions.d495e386.pdf";